import { postRequest } from './api';

const onboardingApi = {  
  async completeOnboarding(data) {
    const response = await postRequest('/api/user/complete-onboarding', data);
    return response;
  }
};

export default onboardingApi;
